import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

// Meta API
export const getAuditTrailMetaService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.AuditTrail.metaApi}`)
    .catch((err) => err.response);

  return setCurrentUser(res);
};

// List API
export const getAuditTrailListService = async (data) => {
  const url =
    `${env}${API_ENDPOINT.AuditTrail.listApi}` +
    `?entityType=${data?.entityType || ''}` +
    `&action=${data?.action || ''}` +
    `&companyId=${data?.companyId || ''}` +
    `&dateFrom=${data?.dateFrom || ''}` +
    `&dateTo=${data?.dateTo || ''}` +
    `&page=${data?.page}` +
    `&pageSize=${data?.pageSize}`;

  const res = await requestInstance.get(url).catch((err) => err.response);

  return setCurrentUser(res);
};

// Details API
export const getAuditTrailDetailsService = async (id) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.AuditTrail.detailApi}/${id}`)
    .catch((err) => err.response);

  return setCurrentUser(res);
};
